import {
  AppBar,
  Drawer,
  Hidden,
  IconButton,
  Toolbar,
  Typography,
} from "@material-ui/core";
import { ExitToApp, Menu } from "@material-ui/icons";
import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { webTitle } from "../../common/AppConstant";
import { appEnv } from "../../model/Common";
import {
  selector as AuthStoreSelector,
  fetchClear as fetchClearAuthStore,
  fetchSignOut,
} from "../../store/AuthStore";

import MenuDrawer from "./MenuDrawer";
import useStyles from "./useStyles";

/**
 * メニューバーコンポーネント.
 *
 * @return {object} コンポーネント
 */
function MenuBar() {
  // スタイル
  const styles = useStyles();

  // Dispatch
  const dispatch = useDispatch();

  // メニュードロワーの表示状態State（ture: 表示、false: 非表示）
  const [isOpenMenuDrawer, setIsOpenMenuDrawer] = React.useState(false);

  // アプリバーの色を決定する関数
  const getAppBarColor = () => {
    const env = process.env.REACT_APP_ENV;
    if (env === appEnv.prodsecond) {
      return "primary";
    }
    if (env === appEnv.stgsecond) {
      return "secondary";
    }
    if (env === appEnv.dev) {
      return "default";
    }
    return "secondary";
  };

  // dev環境用のカスタムスタイル
  const getCustomStyle = () => {
    if (process.env.REACT_APP_ENV === appEnv.dev) {
      return {
        backgroundColor: "#4caf50", // 緑色
        color: "#fff",
      };
    }
    return {};
  };

  // メニューボタン押下時の処理
  const handleMenuButtonClick = () => {
    setIsOpenMenuDrawer(!isOpenMenuDrawer);
  };

  // サインアウトボタン押下時の処理
  const handleSignOutButtonClick = () => {
    dispatch(fetchClearAuthStore());
    dispatch(fetchSignOut());
  };

  const {
    // ログインユーザー名
    loginUserName,
  } = useSelector(AuthStoreSelector);

  return (
    <>
      <AppBar
        className={styles.appBar}
        position="fixed"
        color={getAppBarColor()}
        style={getCustomStyle()}
      >
        <Toolbar>
          <IconButton
            className={styles.menuButton}
            color="inherit"
            onClick={handleMenuButtonClick}
          >
            <Menu />
          </IconButton>
          <Typography variant="h6" noWrap>
            {webTitle}
          </Typography>
          <IconButton
            className={styles.signOutButton}
            color="inherit"
            onClick={handleSignOutButtonClick}
          >
            <Typography>{loginUserName}</Typography>
            <ExitToApp />
          </IconButton>
        </Toolbar>
      </AppBar>
      <nav className={styles.drawer}>
        {/* 画面幅が「md」以上の場合に非表示 */}
        <Hidden mdUp implementation="css">
          <Drawer
            variant="temporary"
            open={isOpenMenuDrawer}
            onClose={handleMenuButtonClick}
            classes={{
              paper: styles.drawerPaper,
            }}
            ModalProps={{
              keepMounted: true,
            }}
          >
            <MenuDrawer />
          </Drawer>
        </Hidden>
        {/* 画面幅が「sm」以下の場合に非表示 */}
        <Hidden smDown implementation="css">
          <Drawer
            variant="permanent"
            open
            classes={{
              paper: styles.drawerPaper,
            }}
          >
            <MenuDrawer />
          </Drawer>
        </Hidden>
      </nav>
    </>
  );
}

export default MenuBar;
